const AboutSection = () => {
    return (

        <section id="about" className="mt-2">
        <div className="diagonal-box">
          <div className="content pt-5">
            <div className="container" id="aboutme">
              <div className="row">
                {/* About Me Section */}
                <div className="col-12 col-md-6 mt-5">
                  <h2 className="text-start mt-2">About Me</h2>
                  <div className="fs-5 text-start mt-4">
                    I turn raw data into intelligent solutions. With a strong foundation in AI engineering and data science, I specialize in:
                    <ul>
                      <li>Designing &amp; deploying end-to-end AI/ML pipelines</li>
                      <li>Deep Learning, NLP, and predictive modelling</li>
                      <li>Transforming complex datasets into actionable insights</li>
                    </ul>
                    Driven by curiosity and a passion for innovation, I bridge the gap between data and real-world impact.
                  </div>
                </div>

                {/* Languages and Technologies Section */}
                <div className="col-12 col-md-6 mt-5">
                  <h2 className="text-md-end text-start mt-2 mb-4">Languages and Technologies</h2>
                  <div className="container px-0">
                    <div className="row text-center justify-content-md-end justify-content-start">
                      {[
                        { name: 'Python', file: 'python.png' },
                        { name: 'PowerBI', file: 'powerbi.png' },
                        { name: 'Airflow', file: 'airflow.png' },
                        { name: 'Git', file: 'git.png' },
                        { name: 'TensorFlow', file: 'tensorflow.png' },
                        { name: 'AWS', file: 'aws.svg' },
                        { name: 'Google Cloud', file: 'google_cloud.svg' },
                        { name: 'Docker', file: 'docker.svg' },
                        { name: 'LangChain', file: 'langchain.svg' },
                        { name: 'n8n', file: 'n8n.svg' },
                        { name: 'Pinecone', file: 'pinecone.svg' },
                        { name: 'Streamlit', file: 'streamlit.svg' },
                      ].map((tech, index) => (
                        <div key={index} className="col-4 col-sm-3 col-md-3 col-lg-2 align-self-end wrapper fs-7 mb-4 d-flex flex-column align-items-center">
                          <img
                            src={`img/languages and tech/${tech.file}`}
                            alt={tech.name}
                            className="icontech"
                            style={{ width: '60%', maxWidth: '80px' }}
                          />
                          <h5 className="mt-3 texticon text-nowrap">{tech.name}</h5>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    )

}

export default AboutSection;